<template>
    <button class="flex-row" :class="class"
        @click="transferClick()"
        :disabled="loading ? true : false">
        <svg class="btn-spinner" viewBox="0 0 50 50"
            v-if="loading">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
        <span>{{ text }}</span>
    </button>
</template>

<script>
import { mapMutations, mapState } from 'vuex/dist/vuex.cjs.js';
export default {
    name: "ConfirmBtn",

    props: {
        class: {
            type: String,
        },
        text: {
            type: String,
        }
    },

    computed: {
        ...mapState('ui', ['loading'])
    },

    emits: ['btnClick'],

    methods: {
        ...mapMutations('ui', ['toggleLoading', 'cancelLoading']),
        transferClick() {
            this.toggleLoading();
            this.$emit('btnClick');
        }
    },

    beforeUnmount() {
        this.cancelLoading();
    }
};
</script>

<style scoped lang="scss">
    .flex-row {
        display: flex;
        align-items: center;
        justify-content: space-around;
        gap: 10px;
    }
</style>